import gql from 'graphql-tag'

export const fetchOrganizationsSigns = () => ({
	query: gql`
		{
			organizations: organizations(
				where: { mail_signature: { _eq: true } }
				order_by: { name: asc }
			) {
				id
				name
			}
		}
	`
})
